import Cookies from 'js-cookie';

const detail = () => import('PC/Pages/Detail');
const index = () => import('PC/Pages/Index');
const Login = () => import('PC/Pages/Login');
const cart = () => import('PC/Pages/Cart');
const pay = () => import('PC/Pages/Pay');
const SearchMore = () => import('PC/search/SearchMore');
const mine = () => import('PC/mine/mine');
const SearchResult = () => import('PC/Pages/SearchResult');
const customize = () => import('PC/Pages/customize');
const compareGoods = () => import('PC/Pages/compareGoods');
const compareGoods2 = () => import('PC/Pages/compareGoods2');
const harmfulCustomize = () => import('PC/Pages/harmfulCustomize');

const pcRouter = [
  {
    path: '',
    redirect: 'index',
  },
  {
    path: 'index',
    component: index,
  },
  {
    path: 'detail/:id',
    component: detail,
  },
  {
    path: 'login',
    component: Login,
  },
  {
    name: 'pcSearch',
    path: 'search',
    component: SearchResult,
  },
  {
    path: 'searchMore/:id',
    component: SearchMore,
  },
  {
    name: 'harmfulCustomize',
    path: 'harmfulCustomize',
    component: harmfulCustomize,
    beforeEnter(to, from, next) {
      if (Cookies.get('isLogin') === undefined) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    name: 'customize',
    path: 'customize',
    component: customize,
    beforeEnter(to, from, next) {
      if (Cookies.get('isLogin') === undefined) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    path: 'mine',
    component: mine,
    beforeEnter(to, from, next) {
      // console.log(Cookies.get('isLogin'));
      if (Cookies.get('isLogin') === undefined) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    path: 'cart',
    component: cart,
    beforeEnter(to, from, next) {
      // console.log(Cookies.get('isLogin'));
      if (Cookies.get('isLogin') === undefined) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    name: 'pay',
    path: 'pay',
    component: pay,
    beforeEnter(to, from, next) {
      // console.log(Cookies.get('isLogin'));
      if (Cookies.get('isLogin') === undefined) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    name: 'compareGoods',
    path: 'compareGoods/:categoryId(\\d+)/:goodsId',
    component: compareGoods,
    beforeEnter(to, from, next) {
      // console.log(Cookies.get('isLogin'));
      if (Cookies.get('isLogin') === undefined) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    name: 'compareGoods2',
    path: 'compareGoods2/:categoryId(\\d+)',
    component: compareGoods2,
    beforeEnter(to, from, next) {
      // console.log(Cookies.get('isLogin'));
      if (Cookies.get('isLogin') === undefined) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    path: '/explain/:code',
    component: () => import('@/views/PC/goodsExplain/explain'),
    meta: { title: '说明书' }
  },
  {//2024年5月24日 支持后面再加个体码的情况，奥德需求
    path: '/explain/:code/:sn',
    component: () => import('@/views/PC/goodsExplain/explain'),
    meta: { title: '说明书' }
  },
];

export default pcRouter;



// WEBPACK FOOTER //
// ./src/router/pc/index.js